let config;
config = {
  apiKey_tiny: "5z36co92kpnlqgl985inch40zgk91hq29180ac4ltkx1udou",
};
export { config }